import { useLocation } from 'react-router';
import { findMatchingRoute } from '@src/shared/localized-path';
import { routes } from '@src/router/Routes';
export function useRoute() {
    const location = useLocation();
    const route = findMatchingRoute(routes, location.pathname);
    return route;
}
